import LinkToDocusaurus from '../LinkToDocusaurus'
import { runner } from '../../docs-routes'

const LinkToRunnerDoc = () =>
  <LinkToDocusaurus path={runner}>
    Learn more about Runner
  </LinkToDocusaurus>

export default LinkToRunnerDoc
